module.exports = __webpack_public_path__ + "assets/img/102002.2b6f6393.png";